export { default } from './Tag';
